import {
  CreateReciboPagoRequestSchema,
  ReciboPagoListQuerySchema,
  ReciboPagoSchema,
  UpdateReciboPagoRequestSchema,
} from '@visep/shared-types/recibos';
import type { Helpers } from './internal.js';
import { makeCrudResource } from './internal.js';

export function createRecibosResource({ request, requestBlob }: Helpers) {
  const crud = makeCrudResource(request, {
    basePath: '/api/recibos',
    schema: ReciboPagoSchema,
    listQuerySchema: ReciboPagoListQuerySchema,
    createSchema: CreateReciboPagoRequestSchema,
    updateSchema: UpdateReciboPagoRequestSchema,
  });
  return {
    ...crud,
    async getPdf(id: string): Promise<Blob> {
      return requestBlob(`/api/recibos/${encodeURIComponent(id)}/pdf`);
    },
  };
}
